// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import CategoryManager from "../../components/dashboard/CategoryManager";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <CategoryManager />
    </DashboardLayout>
  );
}
